@if (loading) {
  <app-visionnaire-loader class="ipe:w-full"/>
}
@if (!loading) {
  <div class="container-fluid overflow-auto scrollbar-visible h-100 bg-white">
    <div class="w-100 h-100">
      <div class="header">
        @if (!etoId) {
          <div class="page-header"><span>{{ model?.modelName | titlecase }}</span>
            <span class="page-subtitle">{{ model?.modelNameId | titlecase }}</span>
            @if (model?.modelObj3DUrl) {
              <a [href]="getModelObj3DUrl"
                 target="_blank"
              >
                <button class="composer-redirect button-secondary">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" fill="currentColor" class="pl-2"
                       viewBox="0 0 16 16">
                    <path
                      d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                    <path
                      d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                  </svg>
                  {{ 'composition.download-3d' | translate }}
                </button>
              </a>
            }
          </div>

        }
        <div class="text-left pb-2">
          @if (model?.academyUrl) {
            <h3 class="m-0">
              <a class="red" [href]="model?.academyUrl" target="_blank">
                {{ 'VISIONNAIRE_ACADEMY_MODEL' | translate }}
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M6 14L14 6" stroke="black"/>
                  <path d="M7 6H14V13" stroke="black"/>
                </svg>
              </a>
            </h3>
          }
        </div>
      </div>
      <div class="flex-container flex-wrap">
        <div (click)="goToCatalogList()" class="catalog-list">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M8.29958 11.9327L3.5 7.13307L8.29958 2.3335" stroke="black"/>
          </svg>
          <span class="catalog-list-label ml-2"> {{ 'TORNA_AL_CATALOGO' | translate }}</span>
        </div>
        <div class="col-12 col-sm-4 p-0">
          <!--            <span class="model-choise"-->
          <!--                  *ngIf="!isCopyingConfiguration()">{{ 'SCEGLI_MODELLO' | translate | uppercase }}</span>-->
          @if (isCopyingConfiguration()) {
            <div class="copying-container">
              <div class="copying-label"> {{ 'SELECT_TO_COPY' | translate }}
                <span class="copying-label-cancel"
                      (click)="cancelCopyingConfiguration()">{{ 'ANNULLA' | translate }}</span>
              </div>
            </div>
          }
        </div>
        <div class="search-container">
          <input #myInput (input)="filterItem(myInput.value)" [(ngModel)]="searchText"
                 aria-describedby="search-text"
                 autofocus class="form-control " id="search-text"
                 placeholder="{{'CERCA_MODELLO' | translate}}"
                 type="text">
          @if (searchText) {
            <button
              type="button"
              class="clear-button"
              (click)="clearInput()">
              <svg class="bi bi-x" fill="currentColor" height="25" viewBox="0 0 16 16" width="25"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
              </svg>
            </button>
          }
          @if (false || eto) {
            <button class="btn btn-primary ml-2 eto-request" (click)="openEtoRequestModal()"
                    type="button">
              {{ 'pages.model.detail.grid.model.detail.grid.modelloSuMisura' | translate }}
            </button>
          }
        </div>
      </div>
      <div class="model-grid">
        <!--          <div class="row mx-0 margin-bottom-30 d-flex flex-space-b flex-nowrap align-items-start">-->
        <!--&lt;!&ndash;            <div class="text-left pb-2">&ndash;&gt;-->
        <!--&lt;!&ndash;              <h3 *ngIf="model?.academyUrl" class="m-0">&ndash;&gt;-->
        <!--&lt;!&ndash;                <a class="red" [href]="model?.academyUrl" target="_blank">&ndash;&gt;-->
        <!--&lt;!&ndash;                  {{ 'VISIONNAIRE_ACADEMY_MODEL' | translate }}&ndash;&gt;-->
        <!--&lt;!&ndash;                  <i class="fa fa-external-link" aria-hidden="true"></i>&ndash;&gt;-->
        <!--&lt;!&ndash;                </a>&ndash;&gt;-->
        <!--&lt;!&ndash;              </h3>&ndash;&gt;-->
        <!--&lt;!&ndash;            </div>&ndash;&gt;-->
        <!--            <div class="col-md-4 pt-4 mb-2">-->
        <!--              <input #myInput (input)="filterItem(myInput.value)" [(ngModel)]="searchText"-->
        <!--                     aria-describedby="search-text"-->
        <!--                     autofocus class="form-control border-radius-0" id="search-text"-->
        <!--                     placeholder="{{'CERCA_MODELLO' | translate}}"-->
        <!--                     type="email">-->
        <!--              <button class="btn btn-primary ml-2 eto-request" *ngIf="false || eto" (click)="openEtoRequestModal()"-->
        <!--                      type="button">-->
        <!--                Modello su misura-->
        <!--              </button>-->
        <!--            </div>-->
        <!--            &lt;!&ndash;            <div class="col-md-4">&ndash;&gt;-->
        <!--            &lt;!&ndash;              <button class="btn btn-primary" (click)="openEtoRequestModal()" type="button">&ndash;&gt;-->
        <!--            &lt;!&ndash;                Modello su misura&ndash;&gt;-->
        <!--            &lt;!&ndash;              </button>&ndash;&gt;-->
        <!--            &lt;!&ndash;            </div>&ndash;&gt;-->
        <!--          </div>-->
        <div class="model-container">
          @if (model && model?.slugModular && composerUserAllowed()) {
            <app-composer-card [model]="model"></app-composer-card>
          }
          @for (modelElement of filteredItems; track modelElement) {
            <div (click)="configureModelElement(modelElement)"
                 class="model">
              <div class="img-container">
                <img [hidden]="!modelElement.imageLoaded"
                     (load)="imageLoaded(modelElement)"
                     [alt]="modelElement?.productName"
                     [src]="convertProductImage(modelElement)"
                     (error)="convertProductImage(modelElement, true)"
                     class="model-image"/>
              </div>
              <div class="flex-sb">
                <div class="d-flex flex-column">
                  <span class="model-name">{{ model?.modelName | titlecase }}</span>
                  <span class="product product-code">{{ modelElement?.productCode }}
                    — {{ modelElement.factorizedName?.subCategory.join(' ') | titlecase }}</span>
                  <span class="product product-dimensions">{{ modelElement.factorizedName?.dimensions }}</span>
                </div>
                @if (modelElement.modelObj3DUrl) {
                  <a
                    [href]="getModelElementObj3DUrl(modelElement)"
                    target="_blank"

                  >
                    <button class="composer-redirect button-secondary" (click)="$event.stopPropagation()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" fill="currentColor"
                           viewBox="0 0 16 16">
                        <path
                          d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                        <path
                          d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                      </svg>
                    </button>
                  </a>
                }

              </div>
            </div>
          }
        </div>
        @if (filteredItems?.length === 0) {
          <div class="col-sm-10 mt-3 text-left">
            <span>{{ "NESSUNA_CORRISPONDENZA" | translate }}</span>
          </div>
        }
      </div>
    </div>
  </div>
}

